import InvoiceFile from '@/general/models/InvoiceFile';
import { Unbinder } from '@/general/services/PushService';
import { removeById } from '@/shared/utils';
import PaymentStatus from '../constants/PaymentStatus';
import DossierContext from './DossierContext';
import PaymentRequest, { PaymentRequestId } from './PaymentRequest';

export default class PaymentRequestContext {
  readonly pushUnbinders: Array<Unbinder> = [];
  public files: Array<InvoiceFile> = [];

  constructor(
    public requests: Array<PaymentRequest> = [],
    public dossierContext: DossierContext,
  ) {
  }

  removeRequest(id: PaymentRequestId): void {
    removeById(this.requests, id);
    this.dossierContext.dossier.paymentStatus = this.getDossierPaymentStatus();
  }

  private getDossierPaymentStatus(): PaymentStatus | null {
    if (this.requests.length === 0) return null;
    return this.requests.some(r => r.status === PaymentStatus.OPEN) ? PaymentStatus.OPEN : PaymentStatus.PAID;
  }

  free(): void {
    this.pushUnbinders.forEach(b => b());
    this.pushUnbinders.splice(0);
  }
}